/* eslint-disable no-underscore-dangle */
import jwt from 'jsonwebtoken'

const config = {
  application: 'Registration Forms Module',
}

if (window._env_) {
  const jwt_env = jwt.decode(window._env_)
  if (jwt_env) {
    config.GOOGLE_API_KEY = jwt_env.GOOGLE_API_KEY
    config.NODE_ENV = jwt_env.NODE_ENV
    config.GA4_REGO_FORM_KEY = jwt_env.GA4_REGO_FORM_KEY
    config.GA4_EVENT_FORM_KEY = jwt_env.GA4_EVENT_FORM_KEY
    config.GA4_EVENT_REGO_FORM_KEY = jwt_env.GA4_EVENT_REGO_FORM_KEY
    config.GA4_SHOP_FORM_KEY = jwt_env.GA4_SHOP_FORM_KEY
  }
} else {
  config.GOOGLE_API_KEY = process.env.GOOGLE_API_KEY
  config.NODE_ENV = process.env.NODE_ENV
  config.GA4_REGO_FORM_KEY = process.env.GA4_REGO_FORM_KEY
  config.GA4_EVENT_FORM_KEY = process.env.GA4_EVENT_FORM_KEY
  config.GA4_EVENT_REGO_FORM_KEY = process.env.GA4_EVENT_REGO_FORM_KEY
  config.GA4_SHOP_FORM_KEY = process.env.GA4_SHOP_FORM_KEY
}

export default config
